import { render, staticRenderFns } from "./f1_tv.vue?vue&type=template&id=d11923b2&"
import script from "./f1_tv.vue?vue&type=script&lang=js&"
export * from "./f1_tv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports